/**
 * Container for new login and its sister pages (forgot password, reset password, etc)
 * They are all have a header text, inside a white box
 */

import React, { Component } from 'react';
import styled from '@emotion/styled';
import { Logo } from './Logo';
import EndInteraction from '../../app/components/EndInteraction';
import { breakpoints } from '../../../styles/constants'

const LogoWrapper = styled.div`
  margin: 50px 0 30px;
`

const Header = styled.div`
  width: 100%;
  font-size: 40px;
  line-height: 52px;
  text-align: center;
  font-weight: 500;
  margin-bottom: 20px;
  color: #262626;  
`

const Container = styled.div` 
  flex-direction: column;
  align-items: center;
  display: flex;    
  overflow: auto;
  padding: 0 20px;
  box-sizing: border-box; 
  overflow-x: hidden;
  padding-bottom: 25px; /* for the inner div's box shadow */
`

const LoginBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  width: 100%;
  max-width: 650px;  
  border-radius: 40px;
  padding: 30px 0;
  align-items: center;
  z-index: 1;
  font-size: 14px;
  box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.1);
  ${breakpoints.SCREEN_S} {
    padding: 30px 20px;
  }
`

const LoginBox = styled.div`
  max-width: 388px;
  width: 100%;   
  display: flex;
  flex-direction: column;  
`

const ErrorMessage = styled.div`
  font-weight: 600;
  color: rgb(250, 98, 77);
  max-width: 473px;
  margin: 10px 0;
  text-align: center;
`

export class LoginContainer extends Component {
  render() {
    return (
      <Container data-qa="Login">
        {/* event will be sent after user authenticates */}
        <EndInteraction interaction="application-startup" />
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
        <LoginBoxWrapper>              
          { this.props.errorMessage && <ErrorMessage data-qa="ErrorMessage" dangerouslySetInnerHTML={{__html: this.props.errorMessage}} />}
          { this.props.header && <Header data-qa="WelcomeText">{ this.props.header }</Header> }
          <LoginBox>       
            {this.props.children}
          </LoginBox>
          {this.props.signInHelpLinks}
        </LoginBoxWrapper>        
      </Container>
    )
  }
}


// WEBPACK FOOTER //
// ./src/modules/login/components/LoginContainer.jsx